// Shared static content for Villa Tutto Passa (language-independent)
export const VILLA = {
  name: "Villa Tutto Passa",
  instagram: "https://www.instagram.com/villa_tuttopassa/",
  instagramHandle: "@villa_tuttopassa",
  email: "caropv2a@gmail.com",
  phone: "06 03 27 46 10",
  location: "Domaine de Cala Rossa, 124 allée des Pins, 20137 Lecci — Corse-du-Sud",
  mapsUrl: "https://share.google/6fv45ffG6NTWVoXsn",
  logo: "/images/3xayp9cj_LOGO_2__blanc_.png.webp",
};

export const IMAGES = {
  hero: "/images/k1aq23ya_26-07-03-Villa_LC_Charpente-high_8.webp",
  poolDusk: "/images/kadvt7di_17.webp",
  poolSea: "/images/kagwqt3k_15.webp",
  interior1: "/images/w8e4kkua_8.webp",
  interior2: "/images/tqkoqg8s_9.webp",
  bath: "/images/y22uwj5p_8.webp",
  maquis: "/images/qv9248r7_16.webp",
  maquisPath: "/images/6gp8dvje_18.webp",
  coast: "/images/f5lbskap_25.webp",
};

// Real photos — Chambre 1 (suite with private terrace & shower)
export const CH1 = {
  bedroom1: "/images/0n5bo93m_2.webp",
  bedroom2: "/images/y9qy6aob_3.webp",
  terraceBed: "/images/gzl56si9_1.webp",
  terraceChairs: "/images/uj7jl4kt_5.webp",
  shower: "/images/wsyovtad_4.webp",
  stairs: "/images/i6ny00wd_6.webp",
  bedroom3: "/images/g2t4aca7_7.webp",
  bath: "/images/y22uwj5p_8.webp",
  wardrobe: "/images/y5d31krv_9.webp",
  terraceLarge: "/images/sk4lnrf1_10.webp",
  wallArt: "/images/0qxrf8ry_11.webp",
  corridor: "/images/35wt3nq5_12.webp",
  dressing: "/images/g2wwf6q1_13.webp",
  bath2: "/images/kkgrjkn0_14.webp",
};

// Real photos — Chambre 2 (suite ambiance sombre & chic)
export const CH2 = {
  p1: "/images/0u9bctwb_3.webp",
  p2: "/images/ldchv5ae_4.webp",
  p3: "/images/e63gqz1e_5.webp",
  p4: "/images/zdasy5n2_7.webp",
  p5: "/images/1sa2ence_9.webp",
};

// Real Google reviews — Villa Tutto Passa (5.0), kept in original French
export const REVIEWS = [
  {
    name: "Violaine de Meaux",
    rating: 5,
    text: "Nous avons passé un séjour absolument exceptionnel dans cette maison. Tout est réuni pour des vacances réussies. L'emplacement est tout simplement paradisiaque : à seulement quelques pas d'une magnifique plage, dans un environnement calme, sécurisé et propice à la détente. La maison est spacieuse, parfaitement équipée et offre un confort remarquable. La piscine et le jacuzzi sont un vrai plus. Un coup de cœur également pour la grande terrasse, véritable lieu de vie où nous avons partagé de merveilleux moments entre amis, du petit-déjeuner aux longues soirées d'été. Une adresse que nous recommandons les yeux fermés !",
  },
  {
    name: "Clémence Jaboulay",
    rating: 5,
    text: "Nous avons passé un séjour absolument exceptionnel dans cette magnifique maison en Corse. Tout était réuni pour des vacances en famille réussies : une propriété parfaitement entretenue, décorée avec beaucoup de goût et offrant des prestations haut de gamme. Les espaces sont vastes, confortables et pensés pour que chacun puisse profiter pleinement de son séjour. Le calme et l'environnement sont tout simplement magnifiques. Nous avons partagé des moments inoubliables autour de la piscine et des repas en terrasse, dans un cadre idyllique. Une adresse d'exception que nous recommandons les yeux fermés !",
  },
  {
    name: "Carole Relave",
    rating: 5,
    text: "Très belle découverte pour cette villa magnifiquement nichée dans ce domaine unique. Nous avons passé un séjour exceptionnel. Tout est parfaitement pensé : larges espaces de vie, un cœur de maison chaleureux, très convivial, super bien équipé. Espaces nuit feutrés, préservés. Tout est décoré avec un goût très sûr. Véritable écrin de verdure, le jardin a été conçu pour offrir plusieurs ambiances, alliant partage, élégance et art de vivre. Conquis.",
  },
  {
    name: "Carels Laurie",
    rating: 5,
    text: "J'ai découvert cette villa dans le cadre d'une visite et j'en garde une excellente impression. La maison est fonctionnelle, lumineuse et parfaitement adaptée à l'accueil de plusieurs personnes. Son emplacement proche de la plage et la qualité générale du bien en font une option très intéressante pour des vacances estivales.",
  },
  {
    name: "Pierre Petitperrin",
    rating: 5,
    text: "Nous avons passé une semaine en famille merveilleuse dans cette villa incroyable ! Je recommande fortement !",
  },
  {
    name: "Camille Sauloup",
    rating: 5,
    text: "Nous avons passé un incroyable séjour. Tout était parfait ! Propreté impeccable et très bon accueil. Nous y retournerons avec plaisir.",
  },
];

// Real photos — Chambre 3 (rez-de-chaussée, accès PMR)
export const CH3 = {
  p1: "/images/1r4f4jgm_26-07-03-Villa_LC_Charpente-high_64.webp",
  p2: "/images/ok2zjwoe_5.webp",
  p3: "/images/tvfu7urh_3.webp",
  p4: "/images/vavrxfe8_2.webp",
  p5: "/images/m53m9f5u_7.webp",
};

// Real photos — Chambre 4 (rez-de-chaussée, ambiance sauge)
export const CH4 = {
  p1: "/images/77sxxk19_1.webp",
  p2: "/images/rxrl892q_2.webp",
  p3: "/images/7s6x48qj_4.webp",
  p4: "/images/rf5ibuxy_6.webp",
  p5: "/images/ncbq806x_7.webp",
};

// Real photos — Chambre 5 (rez-de-chaussée, ambiance terracotta)
export const CH5 = {
  p1: "/images/r81aewx5_1.webp",
  p2: "/images/uirdipkl_4.webp",
  p3: "/images/pkqrs450_5.webp",
  p4: "/images/bm0abys5_6.webp",
};

// Real photos — Salon / pièce de vie
export const SALON = {
  p1: "/images/w8e4kkua_8.webp",
  p2: "/images/4cnq9dlp_12.webp",
  p3: "/images/tqkoqg8s_9.webp",
  p4: "/images/dswv68tc_11.webp",
  p5: "/images/ahcr1oly_10.webp",
  p6: "/images/6o7quwhr_3.webp",
  p7: "/images/499ocupq_4.webp",
  p8: "/images/l0o39sxg_14.webp",
};

// Couloir rez-de-chaussée desservant chambres 4 & 5
export const COULOIR_RDC = [
  "/images/wdb5t13b_2.webp",
];

// Coin TV (petit salon TV entre le salon et la chambre terracotta)
export const COIN_TV = [
  "/images/aczsuiik_6.webp",
  "/images/9lzz6uzs_9.webp",
  "/images/dl2m9mrd_40.webp",
  "/images/t7hz82qi_105.webp",
  "/images/earb12rc_113.webp",
];

// Toilette de service (rdc, bleu Majorelle) + entrée
export const WC_RDC = [
  "/images/tb8e2fdi_5.webp",
  "/images/6g9p3zld_7.webp",
  "/images/elh84mll_19.webp",
];

// Real photos — Cuisine (+ buanderie)
export const CUISINE = [
  "/images/fjsyjs4v_17.webp",
  "/images/kbz5tjhb_15.webp",
  "/images/z0e62mb2_2.webp",
];

// Real photos — Extérieurs (terrasses, cuisine d'été, piscine, jardin)
export const EXT = {
  pergola: "/images/c2qliukf_11__bis_.webp",
  pool: "/images/kagwqt3k_15.webp",
  sunbeds: "/images/kadvt7di_17.webp",
  sailLounge: "/images/6gp8dvje_18.webp",
  garden: "/images/qv9248r7_16.webp",
  villaPool: "/images/f5lbskap_25.webp",
  drone: "/images/ab14437p_26-07-03-Villa_LC_Charpente-high_11.webp",
  gardenVilla: "/images/3tmbdkto_26-07-03-Villa_LC_Charpente-high_8.webp",
  jacuzzi: "/images/gnvgarcj_23.webp",
  swing: "/images/fv3vdfas_26-07-03-Villa_LC_Charpente-high_17.webp",
  poolFront: "/images/i8jq2e6i_26-07-03-Villa_LC_Charpente-high_18.webp",
  carport: "/images/3aa0858db5133bdebd58167caa91a1617a0c34d84b821356fb731ab5bd07.webp",
  pergolaDetail: "/images/lv69ms6m_26-07-03-Villa_LC_Charpente-high_68.webp",
  entrance: "/images/g2oblwp7_26.webp",
  fiatCharge: "/images/721adff9d74094640c876624e5ef279c53def358caffb2f8e1083ced11d7.webp",
  nightLounge: "/images/plnvx0j4_28.webp",
  nightPetanque: "/images/ao056apk_31.webp",
  nightDining: "/images/5liggpuz_32.webp",
  nightPool: "/images/ej57g76x_33.webp",
  nightVilla: "/images/oig7z7ge_34.webp",
};

// Interactive floor plan — clickable rooms revealing matching photos (labels translated via i18n)
// Photos additionnelles — Ch. noire (douche)
export const CH_NOIRE_EXTRA = [
  "/images/p0v34w2v_2.webp",
];

export const ROOMS = [
  { id: "terrasse", x: 4, y: 68, w: 72, h: 28, photos: [EXT.pergola, EXT.sailLounge, EXT.nightLounge, EXT.nightDining, EXT.jacuzzi, EXT.swing, EXT.nightPetanque] },
  { id: "piscine", x: 78, y: 36, w: 18, h: 60, photos: [EXT.villaPool, EXT.poolFront, EXT.pool, EXT.nightPool, EXT.nightVilla, EXT.drone, EXT.sunbeds] },
  { id: "garage", x: 4, y: 96, w: 20, h: 10, photos: [EXT.pergolaDetail, EXT.carport, EXT.fiatCharge] },
  { id: "salon", x: 4, y: 4, w: 40, h: 34, photos: [SALON.p8, SALON.p7, SALON.p1, SALON.p2, SALON.p6, SALON.p3] },
  { id: "cuisine", x: 4, y: 40, w: 40, h: 26, photos: [...CUISINE] },
  { id: "sdb", x: 78, y: 4, w: 18, h: 30, photos: [EXT.entrance, ...WC_RDC] },
  { id: "cointv", x: 40, y: 40, w: 6, h: 10, photos: [...COIN_TV] },
  { id: "chambre1", x: 46, y: 4, w: 30, h: 10, photos: ["/images/l9n5exs7_89.webp", CH2.p2, CH2.p3, CH2.p1, ...CH_NOIRE_EXTRA, CH2.p5, "/images/225awlk2_1111.webp"] },
  { id: "chambre2", x: 46, y: 16, w: 30, h: 10, photos: [CH1.stairs, CH1.bedroom2, CH1.bath, CH1.shower, CH1.terraceBed, CH1.terraceLarge] },
  { id: "chambre3", x: 46, y: 28, w: 30, h: 10, photos: ["/images/zej1jfs0_8.webp", CH3.p1, CH3.p2, CH3.p3, CH3.p4, CH3.p5] },
  { id: "chambre4", x: 46, y: 40, w: 30, h: 10, photos: [...COULOIR_RDC, CH5.p2, CH5.p3, CH5.p4, CH5.p1] },
  { id: "chambre5", x: 46, y: 52, w: 30, h: 10, photos: [CH4.p2, CH4.p4, CH4.p3, CH4.p5] },
];
